@if (wallet()) {
  <div class="wrapper" [ngClass]="{ onNewBalance: onNewBalance() }" (click)="toggle()">
    <div class="crypto-coin">
      <icon [name]="wallet()?.code.toLowerCase()" color="primary-color" size="24" />
    </div>
    <div class="balance">
      <p>{{ balance$ | async | cryptoBalance: wallet() }}</p>
    </div>
    <div class="arrow" [ngClass]="{ isOpen: isOpen() }">
      <icon name="arrow-down" size="13" />
    </div>
  </div>
}
